import { Spinner, Typography } from "@material-tailwind/react";
import React from "react";
import toast from "react-hot-toast";
import { Navigate, useLocation } from "react-router-dom";
import { usePlan } from "../../Context/PlanContext";

function ProtectedRoute({ children, ...rest }) {
  const user = localStorage.getItem("user");
  const { currentPlan } = usePlan();
  const { pathname } = useLocation();
  const path = pathname.split("/").filter(Boolean)[0];

  // Redirect to login page only if user is not authenticated
  if (!user) {
    return <Navigate to={"/"} replace />;
  }

  if (currentPlan === undefined) {
    return (
      <div className="h-screen flex flex-col gap-2 items-center justify-center">
        <Spinner color="blue-gray" className="h-16 w-16" />
        <Typography
          variant="paragraph"
          className="text-secondary font-semibold"
        >
          Refreshing...
        </Typography>
      </div>
    );
  }

  if (rest.checkAccess && !currentPlan[path]) {
    toast?.error("Please upgrade your plan to access this feature.");
    return <Navigate to={"/unauthorized"} replace />;
  }

  // If user is authenticated, render the children components
  return children;
}

export default ProtectedRoute;
